var _circle, _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJournalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "url(#paint0_linear_9491_32380)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0633 15.808C18.0633 15.1659 19.5066 13.058 20.4385 13.058H23.6876V9.58936C23.6876 9.27918 23.4363 9.02747 23.1251 9.02747H12.8765C11.5359 9.02747 9.93945 9.64549 9.93945 12.5892V21.3393C9.93945 21.9712 10.013 22.4956 10.1413 22.9295C10.1509 22.9996 10.1728 23.0653 10.2052 23.1253C10.7143 24.5518 11.8684 24.9011 12.8765 24.9011H23.1251C23.3567 24.9011 23.563 24.7582 23.6477 24.5422C23.7324 24.3263 23.6747 24.0801 23.5042 23.9233C23.4979 23.9176 22.9266 23.3821 22.917 22.6986C22.9114 22.291 23.1134 21.8856 23.517 21.4931C23.5182 21.4925 23.5192 21.4919 23.5182 21.4919C23.5182 21.4913 23.5194 21.4908 23.5194 21.4908C23.5194 21.4908 23.52 21.4908 23.5205 21.4902L23.5211 21.4896L23.5217 21.4884C23.5323 21.4778 23.5424 21.4677 23.5514 21.4565C23.552 21.4559 23.552 21.4559 23.552 21.4554C23.5526 21.4554 23.5526 21.4548 23.5532 21.4542C23.6322 21.3623 23.6817 21.2445 23.6872 21.1155C23.6872 21.1049 23.6878 21.0953 23.6878 21.0846V18.5578H20.4387C19.5066 18.5581 18.0633 16.4503 18.0633 15.8082L18.0633 15.808ZM22.0452 23.7755H12.8765C12.0422 23.7755 11.5218 23.461 11.2627 22.7601C11.2873 21.9039 11.6782 21.6505 13.8444 21.6505H22.0247C21.8626 21.9952 21.7853 22.3547 21.7926 22.7259C21.8004 23.1217 21.9064 23.4773 22.0455 23.7755H22.0452Z",
    fill: "url(#paint1_linear_9491_32380)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.315 13.8075H20.4409C20.0265 13.8075 18.8159 15.4634 18.8159 15.807C18.8159 16.1509 20.0265 17.8066 20.4409 17.8066H24.315C24.7288 17.8066 25.0647 17.4702 25.0647 17.0564V14.558C25.0647 14.1442 24.7294 13.8076 24.315 13.8076V13.8075ZM21.3464 16.7448C20.8283 16.7448 20.4088 16.3253 20.4088 15.8072C20.4088 15.2891 20.8283 14.8696 21.3464 14.8696C21.8645 14.8696 22.284 15.2891 22.284 15.8072C22.284 16.3253 21.8645 16.7448 21.3464 16.7448Z",
    fill: "url(#paint2_linear_9491_32380)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9491_32380",
    x1: 3.88889,
    y1: 29.8148,
    x2: 35,
    y2: 11.8827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF939C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEC7CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9491_32380",
    x1: 11.1179,
    y1: 23.7119,
    x2: 27.9015,
    y2: 12.0779,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC75B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA94D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9491_32380",
    x1: 19.3515,
    y1: 17.507,
    x2: 23.7564,
    y2: 11.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC75B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA94D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournalIcon);
export default __webpack_public_path__ + "static/media/JournalIcon.722436dfb196594973f2235ed917e6df.svg";
export { ForwardRef as ReactComponent };